module.exports = __webpack_public_path__ + "static/media/alj-our-locations-in-saudi-arabia.54e64fc4.mp4";